export default __webpack_public_path__ + "static/media/kr.e44d26e3.svg";